<template>
    <v-tooltip
        :disabled="!isOverflowing"
        max-width="1000"
        bottom
    >
        <template v-slot:activator="{ on }">
            <div
                class="sidebar-value"
                ref="sidebarValue"
                :class="icon ? 'text-wrapping' : ''"
                v-on="on"
            >
                <icon
                    v-if="icon"
                    small
                    :color="icon.color"
                    :icon="icon.name"
                />
                <template v-if="showValueTitle">
                    <span class="body-2 grey--text ml-3">{{ fieldTitle }}</span>&nbsp;
                    <span>{{ fieldValue }}</span>
                </template>
                <template v-else>
                    <span :class="icon ? 'ml-3' : ''">{{ fieldValue }}</span>
                </template>
            </div>
        </template>
        <span>{{ fieldValue }}</span>
    </v-tooltip>
</template>

<script>

import {formatCustomFieldValue} from "../../../composables/use-custom-fields";
import {computed, ref, onMounted} from "@vue/composition-api";

export default {
    name: "BasicCustomField",
    methods: {formatCustomFieldValue},
    props: {
        relatedObject: {
            type: Object,
            required: true
        },
        field: {
            type: Object,
            required: true
        },
        icon: {
            type: Object,
            default: null
        },
        showValueTitle: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const sidebarValue = ref(null)
        const isOverflowing = ref(false)

        const fieldValue = computed(() => {
            return formatCustomFieldValue(props.field.value, props.field.field, props.relatedObject)
        })

        const fieldTitle = computed(() => {
            return props.field.field.title
        })

        const checkOverflow = () => {
            isOverflowing.value = sidebarValue.value.scrollWidth > sidebarValue.value.clientWidth;
        };

        onMounted(() => {
            setTimeout(() => {
                checkOverflow()
            }, 100)
        });

        return {
            fieldValue,
            fieldTitle,
            sidebarValue,
            isOverflowing,
        }
    }
}

</script>

<style scoped lang="scss">
.text-wrapping {
    white-space: nowrap;
}
</style>